import DataTable from '../../../components/table/DataTable';
import { useNavigate, useParams } from 'react-router-dom';
import { NumericalSeriesCounter } from '../../../types/NumericalSeries';
import { paths } from '../../RouterContainer';
import { columns } from '../../../components/columns/Company/NumericalSeriesCountersColumn';
import { useTranslation } from '../../../context/translationContext';

interface Props {
  counters: NumericalSeriesCounter[];
}

/**
 * Page component represents numerical series counter
 */
export const NumericalSeriesCounters = ({ counters }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id: numericalSerieId, companyId } = useParams();
  const isCurrent = window.location.pathname.includes(`current`);
  /**
   * Redirects to numerical series counter edit page
   * @param id
   */
  const onEditItem = (id: string | number) => {
    if (!id) return;
    const counter = counters.find((x: NumericalSeriesCounter) => x.id === id)?.counter;
    navigate(
      `/${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${
        paths.NUMERICAL_SERIES
      }/${numericalSerieId}/${paths.NUMERICAL_SERIES_COUNTERS}/edit/${id}`,
      { state: counter },
    );
  };

  return (
    <div className="w-3/4 pl-10">
      <h1 className="text-2xl font-bold mb-10">{t('page.numerical-serie.headline-counters')}</h1>
      <DataTable data={counters} columns={columns} handleEdit={onEditItem} />
    </div>
  );
};
